    <div [ngClass]="userLoggedIn === 'true'? 'chatLoaderContainer': 'abChatLoaderContainer'" (click)="openChatWindow()" *ngIf="!commonService.getisAiModuleCalled()">
        <div class="row">
            <div class="col-6 chatHint" >
                <span>
                    {{'ct.global.msg.chat-circle-desc' | translate}}
                </span>
            </div>
           
            
            <div class="col-2 displayHint" placement="end" >
                <img *ngIf="!unreadGif;" src="assets/img/floraIcon.png">
                <img *ngIf="unreadGif" src="assets/img/flora_new_msg.gif">
            </div>
        </div>
    </div>

    <div *ngIf="commonService.getisAiModuleCalled()">

                <img (click)="openAiChatWindow()" class="ai-chat-hint tooltip-index" *ngIf="!unreadGif;" src="assets/img/sparkIcon.png" triggers="mouseenter:mouseleave" placement="right" ngbTooltip=" {{'ct.openai.global.aitooltip.txet' | translate}}">
                <img (click)="openAiChatWindow()" *ngIf="unreadGif" src="assets/img/flora_new_msg.gif" ngbTooltip=" {{'ct.openai.global.aitooltip.txet' | translate}}">

        </div>

